// CSS for the refresh scenes. Rendered as a literal <style> element inside
// each scene's <svg> to bypass preact-cli's CSS Modules name-hashing — class
// selectors here match the unhashed `class='refresh-scene'` / `class='drift'`
// attributes the scenes use.

export const SCENE_CSS = `
@keyframes refreshDrift800 {
    from { transform: translateX(0); }
    to   { transform: translateX(-800px); }
}
@keyframes refreshWobble {
    0%, 100% { transform: rotate(-4deg); }
    50%      { transform: rotate(4deg); }
}
@keyframes refreshIconSwoop {
    0%   { transform: translate(0, 0)   rotate(0);    opacity: 1; }
    100% { transform: translate(50px, -40px) rotate(20deg); opacity: 0; }
}
@keyframes refreshIconFlash {
    0%, 100% { filter: brightness(1) drop-shadow(0 0 0 transparent); }
    50%      { filter: brightness(1.4) drop-shadow(0 0 8px #ffc107); }
}
@keyframes refreshDogShake {
    0%, 100% { transform: rotate(0); }
    25%      { transform: rotate(-6deg); }
    75%      { transform: rotate(6deg); }
}
@keyframes refreshHeroBob {
    0%, 100% { transform: translateY(0); }
    50%      { transform: translateY(-4px); }
}
@keyframes refreshRibbon {
    0%   { transform: translateX(300px); opacity: 1; }
    70%  { transform: translateX(0);     opacity: 1; }
    100% { transform: translateX(0);     opacity: 0; }
}
@keyframes refreshHeartPop {
    0%   { opacity: 0; transform: translateY(8px)   scale(0.4); }
    30%  { opacity: 1; transform: translateY(0)     scale(1.15); }
    60%  { opacity: 1; transform: translateY(-4px)  scale(1); }
    100% { opacity: 0; transform: translateY(-16px) scale(1); }
}
@keyframes refreshSpeedLine {
    0%   { opacity: 0; transform: translateX(60px); }
    30%  { opacity: 1; }
    100% { opacity: 0; transform: translateX(-120px); }
}
@keyframes refreshDogStride {
    0%, 100% { transform: rotate(26deg); }
    50%      { transform: rotate(-26deg); }
}
@keyframes refreshDogBob {
    0%, 100% { transform: translateY(0); }
    50%      { transform: translateY(-1.5px); }
}
@keyframes refreshAuroraShimmer {
    0%, 100% { opacity: 0.55; transform: translateX(0)     scaleY(1); }
    50%      { opacity: 0.9;  transform: translateX(-14px) scaleY(1.12); }
}
@keyframes refreshAuroraFlare {
    0%   { opacity: 0.7; transform: scaleY(1); }
    40%  { opacity: 1;   transform: scaleY(1.35); }
    100% { opacity: 0.8; transform: scaleY(1.1); }
}
@keyframes refreshCheckpointPass {
    0%   { transform: translateX(40px);   opacity: 0; }
    12%  { opacity: 1; }
    85%  { opacity: 1; }
    100% { transform: translateX(-300px); opacity: 0; }
}
@keyframes refreshSnowSpray {
    0%   { opacity: 0.9; transform: translate(0, 0)        scale(0.6); }
    100% { opacity: 0;   transform: translate(-26px, -14px) scale(1.5); }
}
.refresh-scene .drift {
    animation-name: refreshDrift800;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
.mushing-team .dog-leg {
    transform-box: fill-box;
    transform-origin: 50% 0;
}
.mushing-team .snow-puff {
    transform-box: fill-box;
    transform-origin: 50% 50%;
}
`;
